import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalMiddleWrapper from "layouts/wrapper/VerticalMiddleWrapper";
import style from "./MobileAddCartBase.module.css"
import { useEffect } from "react";
import P from "components/P";


function MobileAddCartBaseHeader({ title, modalClose, headerStyle }) {
    return (
        <div className={style.mobileHeader} style={headerStyle}>
            <HorizontalFlex>
                {/* <FlexChild width={"42%"}>

                </FlexChild> */}
                <FlexChild>
                    <VerticalMiddleWrapper>
                        <P size={16}>{title}</P>
                    </VerticalMiddleWrapper>
                </FlexChild>
                <FlexChild width={50}>
                    <VerticalMiddleWrapper>
                        <a className={style.headerCloseButton} onClick={modalClose}>
                            {' '}&times;{' '}
                        </a>
                    </VerticalMiddleWrapper>
                </FlexChild>
            </HorizontalFlex>
        </div>
    );
}
export default MobileAddCartBaseHeader;